"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandText = exports.ToggleFilterContentButton = exports.CollapsePanelWrapper = exports.CollapseWrapper = exports.CollapseIcon = exports.FiltersTitle = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const styled_breakpoints_1 = require("styled-breakpoints");
const { Panel: CollapsePanel } = antd_1.Collapse;
exports.FiltersTitle = styled_components_1.default.h3 `
	color: ${({ theme }) => theme.color.brand4};
	padding: 0;
	margin-bottom: 0;
	font-size: 24px;
`;
exports.CollapseIcon = (0, styled_components_1.default)(icons_1.DownOutlined) `
	rotate: ${({ rotate }) => rotate};
	transition: 0.2s;

	svg {
		width: 20px;
		height: 20px;
	}
`;
exports.CollapseWrapper = (0, styled_components_1.default)(antd_1.Collapse) `
	.ant-collapse-header {
		padding: 0 16px 0 0 !important;
	}

	${(0, styled_breakpoints_1.up)('lg')} {
		.ant-collapse-header {
			display: none !important;
		}
	}
`;
exports.CollapsePanelWrapper = (0, styled_components_1.default)(CollapsePanel) `
	.ant-collapse-content-box {
		padding: 0;
	}
`;
exports.ToggleFilterContentButton = styled_components_1.default.button `
	padding: 0.5rem;
	color: ${({ theme }) => theme.color.brand1};
	border-radius: 0.3rem;
	text-decoration: underline;
	font-weight: bold;
	font-size: 0.9rem;
	border: none;
	width: 100%;
	text-align: center;
	cursor: pointer;

	:focus {
		color: ${({ theme }) => theme.color.brand1};
		background: none;
		text-decoration: underline;
	}
	:hover {
		color: ${({ theme }) => theme.color.brand4};
		border-color: transparent;
		background: rgba(0, 0, 0, 0.018);
	}
`;
exports.ExpandText = styled_components_1.default.div `
	right: 0 !important;
	display: flex !important;
	align-items: center;
	color: ${({ theme }) => theme.color.gray6};
`;
